module.exports = __webpack_public_path__ + "static/media/Question1.ef8c3fb5.svg";